// Model/world coordinates use millimetres; angles use degrees.
export function snap(value, grid) {
  return Math.round(value / grid) * grid;
}

export function normalizeAngle(angle) {
  let next = Number.isFinite(Number(angle)) ? Number(angle) : 0;
  next %= 360;
  if (next > 180) next -= 360;
  if (next <= -180) next += 360;
  return next;
}

export function rotateWorldPoint(point, center, angleDeg) {
  const angle = (Number(angleDeg) || 0) * Math.PI / 180;
  const cos = Math.cos(angle);
  const sin = Math.sin(angle);
  const dx = (Number(point?.x) || 0) - (Number(center?.x) || 0);
  const dz = (Number(point?.z) || 0) - (Number(center?.z) || 0);
  return {
    x: (Number(center?.x) || 0) + dx * cos - dz * sin,
    z: (Number(center?.z) || 0) + dx * sin + dz * cos
  };
}
